
import Layout from '@/layout/index.vue'

export const teachingProtectionMap = {
  path: '/teachingProtection',
  component: Layout,
  meta: { title: '保教', code: 699067 },
  children: [
    {
      path: 'attendanceManage',
      component: () => import('@/views/teachingProtection/attendanceManage/index.vue'),
      meta: { title: '考勤管理', drop: true, code: 656725 },
      children: [
        {
          path: 'static',
          component: () => import('@/views/teachingProtection/attendanceManage/static/list.vue'),
          meta: { title: '统计报表', code: 797917 }
        },
        {
          path: 'attendance',
          component: () => import('@/views/teachingProtection/attendanceManage/attendance/attendance.vue'),
          meta: { title: '考勤统计', code: 589611 }
        },
        {
          path: 'absence',
          component: () => import('@/views/teachingProtection/attendanceManage/absence/absence.vue'),
          meta: { title: '缺勤统计', code: 591985 }
        }
      ]
    },
    {
      path: 'teachManage',
      component: () => import('@/views/teachingProtection/index.vue'),
      meta: { title: '教学管理', drop: true, code: 549203 },
      children: [
        {
          path: 'teach',
          component: () => import('@/views/teachingProtection/teachManage/teaching.vue'),
          meta: { title: '教学管理', code: 691088 }
        },
        {
          path: 'monthReview',
          component: () => import('@/views/teachingProtection/teachManage/monthReview.vue'),
          meta: { title: '月评管理', code: 679487 }
        }
      ]
    },
    {
      path: 'childCare',
      component: () => import('@/views/teachingProtection/index.vue'),
      meta: { title: '保育管理', drop: true, code: 775838 },
      children: [
        {
          path: 'life',
          component: () => import('@/views/teachingProtection/childCare/life.vue'),
          meta: { title: '生活记录', code: 824171 }
        },
        {
          path: 'drinkWater',
          component: () => import('@/views/teachingProtection/childCare/drinkWater.vue'),
          meta: { title: '饮水统计', code: 678660 }
        },
        {
          path: 'lunch',
          component: () => import('@/views/teachingProtection/childCare/lunch.vue'),
          meta: { title: '用餐订餐', code: 939447 }
        },
        {
          path: 'disinfectCheck',
          component: () => import('@/views/teachingProtection/childCare/disinfectCheck.vue'),
          meta: { title: '消毒检查', code: 950060 }
        },
        {
          path: 'outCampus',
          component: () => import('@/views/teachingProtection/childCare/outCampus.vue'),
          meta: { title: '出园检查', code: 925291 }
        }
      ]
    },
    {
      path: 'innerCheck',
      component: () => import('@/views/teachingProtection/index.vue'),
      meta: { title: '内部排查', drop: true, code: 731581 },
      children: [
        {
          path: 'safe',
          component: () => import('@/views/teachingProtection/innerCheck/safe.vue'),
          meta: { title: '安全排查', code: 931956 }
        },
        {
          path: 'fire',
          component: () => import('@/views/teachingProtection/innerCheck/fire.vue'),
          meta: { title: '防火排查', code: 809599 }
        },
        {
          path: 'goods',
          component: () => import('@/views/teachingProtection/innerCheck/goods.vue'),
          meta: { title: '物品检查', code: 752127 }
        }
      ]
    },
    {
      path: 'healthStatic',
      component: () => import('@/views/teachingProtection/index.vue'),
      meta: { title: '健康管理', drop: true, code: 830391 },
      children: [
        {
          path: 'sick',
          component: () => import('@/views/teachingProtection/healthStatic/sickStatic.vue'),
          meta: { title: '伤病统计', code: 685468 }
        },
        {
          path: 'observeRecord',
          component: () => import('@/views/teachingProtection/healthStatic/observeRecord.vue'),
          meta: { title: '健康观察', code: 930525 }
        },
        {
          path: 'health',
          component: () => import('@/views/teachingProtection/healthStatic/health.vue'),
          meta: { title: '晨检统计', code: 831837 }
        },
        {
          path: 'afternoonHealth',
          component: () => import('@/views/teachingProtection/healthStatic/afternoonHealth.vue'),
          meta: { title: '午检统计', code: 831837 }
        },
        {
          path: 'bodyData',
          component: () => import('@/views/teachingProtection/healthStatic/bodyData.vue'),
          meta: { title: '身体数据', code: 902805 }
        },
        {
          path: 'dishAcceptance',
          component: () => import('@/views/teachingProtection/healthStatic/dishAcceptance.vue'),
          meta: { title: '菜品验收', code: 884140 }
        },
        {
          path: 'dishSample',
          component: () => import('@/views/teachingProtection/healthStatic/dishSample.vue'),
          meta: { title: '菜品留样', code: 865169 }
        },
        // {
        //   path: 'wristStrap',
        //   component: () => import('@/views/teachingProtection/healthStatic/wristStrap.vue'),
        //   meta: { title: '手环监控' code: 103101103}
        // },
        {
          path: 'menuManage',
          component: () => import('@/views/teachingProtection/index.vue'),
          meta: { title: '菜谱管理', code: 518511, drop: true },
          children: [
            {
              path: 'list',
              component: () => import('@/views/teachingProtection/menuManage/list.vue'),
              meta: { title: '菜谱列表' }
            },
            {
              path: 'add/:op/:id',
              name: 'add',
              component: () => import('@/views/teachingProtection/menuManage/add.vue'),
              meta: { title: '菜谱添加' }
            },
            {
              path: 'edit/:op/:id',
              name: 'edit',
              component: () => import('@/views/teachingProtection/menuManage/add.vue'),
              meta: { title: '菜谱编辑' }
            },
            {
              path: 'view/:op/:id',
              name: 'view',
              component: () => import('@/views/teachingProtection/menuManage/add.vue'),
              meta: { title: '菜谱查看' }
            }
          ]
        }
      ]
    },
    {
      path: 'motion',
      component: () => import('@/views/teachingProtection/motion/index.vue'),
      meta: { title: '运动评估', code: 957213, drop: true },
      children: [
        {
          path: 'plan',
          meta: { title: '评估计划', code: 673421 },
          component: () =>
            import('@/views/teachingProtection/motion/plan/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/list.vue'
                ),
              meta: { title: '评估计划列表', keepAlive: true }
            },
            {
              path: 'hideList',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/list.vue'
                ),
              meta: { title: '已隐藏评估计划列表', keepAlive: true }
            },
            {
              path: 'add',
              name: 'PlanAdd',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/add.vue'
                ),
              meta: { title: '创建评估计划' }
            },
            {
              path: 'detail',
              name: 'PlanDetail',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/add.vue'
                ),
              meta: { title: '查看评估计划' }
            },
            {
              path: 'edit',
              name: 'PlanEdit',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/add.vue'
                ),
              meta: { title: '编辑评估计划' }
            },
            {
              path: 'idcard',
              component: () =>
                import(
                  '@/views/teachingProtection/motion/plan/idcard.vue'
                ),
              meta: { title: '身份码打印' }
            }
          ]
        },
        {
          path: 'report',
          meta: { title: '评估报告', code: 771600 },
          component: () => import('@/views/teachingProtection/motion/report/index.vue'),
          children: [
            {
              path: 'list',
              component: () => import('@/views/teachingProtection/motion/report/list.vue'),
              meta: { title: '评估报告列表', keepAlive: true }
            },
            {
              path: 'history',
              component: () => import('@/views/teachingProtection/motion/report/history.vue'),
              meta: { title: '历史报告' }
            },
            {
              path: 'download',
              component: () => import('@/views/teachingProtection/motion/report/download/index.vue'),
              meta: { title: '群体报告下载' }
            }
          ]
        }
      ]
    },
    {
      path: 'form',
      component: () => import('@/views/teachingProtection/form/index.vue'),
      meta: { title: '表单管理', code: 724450, drop: true },
      children: [
        {
          path: 'collectPlan',
          meta: { title: '采集计划', code: 129719 },
          component: () =>
            import('@/views/teachingProtection/form/collectPlan/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/teachingProtection/form/collectPlan/list.vue'
                ),
              meta: { title: '采集计划列表', keepAlive: true }
            },
            {
              path: 'add',
              name: 'PlanAdd',
              component: () =>
                import(
                  '@/views/teachingProtection/form/collectPlan/add.vue'
                ),
              meta: { title: '创建采集计划' }
            },
            {
              path: 'detail',
              name: 'PlanDetail',
              component: () =>
                import(
                  '@/views/teachingProtection/form/collectPlan/add.vue'
                ),
              meta: { title: '查看采集计划' }
            },
            {
              path: 'edit',
              name: 'PlanEdit',
              component: () =>
                import(
                  '@/views/teachingProtection/form/collectPlan/add.vue'
                ),
              meta: { title: '编辑采集计划' }
            }
          ]
        },
        {
          path: 'collectRecord',
          meta: { title: '采集记录', code: 434996 },
          component: () =>
            import('@/views/teachingProtection/form/collectRecord/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/teachingProtection/form/collectRecord/list.vue'
                ),
              meta: { title: '采集记录列表', keepAlive: true }
            }
          ]
        }
      ]
    },
    {
      path: 'assessment',
      component: () => import('@/views/teachingProtection/form/index.vue'),
      meta: { title: '评测统计', code: 132689, drop: true },
      children: [
        {
          path: 'assessment',
          meta: { title: '评测统计', code: 677985 },
          component: () =>
            import('@/views/teachingProtection/assessment/assessment/index.vue'),
          children: [
            {
              path: 'main',
              component: () =>
                import(
                  '@/views/teachingProtection/assessment/assessment/main.vue'
                ),
              meta: { title: '群体分析', keepAlive: true }
            },
            {
              path: 'height',
              component: () =>
                import(
                  '@/views/teachingProtection/assessment/assessment/height/index.vue'
                ),
              meta: { title: '身高分布' }
            },
            {
              path: 'bmi',
              meta: { title: 'BMI分布' },
              component: () =>
                import(
                  '@/views/teachingProtection/assessment/assessment/bmi/index.vue'
                )
            },
            {
              path: 'avg',
              meta: { title: '' },
              component: () => import('@/views/teachingProtection/assessment/assessment/avg/index.vue'),
              children: [
                {
                  path: 'index',
                  meta: { title: '综合能力均分' },
                  component: () => import('@/views/teachingProtection/assessment/assessment/avg/main.vue')
                },
                {
                  path: 'child',
                  meta: { title: '子能区' },
                  component: () => import('@/views/teachingProtection/assessment/assessment/avg/child.vue')
                }
              ]
            },
            {
              path: 'distribution',
              component: () => import('@/views/teachingProtection/assessment/assessment/distribution/index.vue'),
              meta: { title: '综合能力分布' }
            }
          ]
        }
        // {
        //   path: 'analysis',
        //   meta: { title: '群体分析', code: 677985 },
        //   component: () =>
        //     import('@/views/teachingProtection/assessment/analysis/index.vue'),
        //   children: [
        //     {
        //       path: 'main',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/analysis/main.vue'
        //         ),
        //       meta: { title: '群体分析', keepAlive: true }
        //     },
        //     {
        //       path: 'height',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/analysis/height/index.vue'
        //         ),
        //       meta: { title: '身高分布' }
        //     },
        //     {
        //       path: 'bmi',
        //       meta: { title: 'BMI分布' },
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/analysis/bmi/index.vue'
        //         )
        //     },
        //     {
        //       path: 'avg',
        //       meta: { title: '' },
        //       // redirect: '/teachingProtection/assessment/analysis/avg/index',
        //       component: () => import('@/views/teachingProtection/assessment/analysis/avg/index.vue'),
        //       children: [
        //         {
        //           path: 'index',
        //           meta: { title: '综合能力均分' },
        //           component: () => import('@/views/teachingProtection/assessment/analysis/avg/main.vue')
        //         },
        //         {
        //           path: 'child',
        //           meta: { title: '子能区' },
        //           component: () => import('@/views/teachingProtection/assessment/analysis/avg/child.vue')
        //         }
        //       ]
        //     },
        //     {
        //       path: 'distribution',
        //       component: () => import('@/views/teachingProtection/assessment/analysis/distribution/index.vue'),
        //       meta: { title: '综合能力分布' }
        //     }
        //   ]
        // },
        // {
        //   path: 'compare',
        //   meta: { title: '群体对比', code: 562189 },
        //   component: () =>
        //     import('@/views/teachingProtection/assessment/compare/index.vue'),
        //   children: [
        //     {
        //       path: 'main',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/compare/main.vue'
        //         ),
        //       meta: { title: '群体对比', keepAlive: true }
        //     },
        //     {
        //       path: 'height',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/compare/height/index.vue'
        //         ),
        //       meta: { title: '身高分布' }
        //     },
        //     {
        //       path: 'bmi',
        //       meta: { title: 'BMI分布' },
        //       component: () =>
        //         import('@/views/teachingProtection/assessment/compare/bmi/index.vue')
        //     },
        //     {
        //       path: 'avg',
        //       meta: { title: '综合能力均分' },
        //       component: () => import('@/views/teachingProtection/assessment/compare/avg/index.vue')
        //     },
        //     {
        //       path: 'distribution',
        //       meta: { title: '综合能力分布' },
        //       component: () => import('@/views/teachingProtection/assessment/compare/distribution/index.vue')
        //     },
        //     // 以下是班级对比页面
        //     {
        //       path: 'heightClass',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/compare/heightClass/index.vue'
        //         ),
        //       meta: { title: '身高分布' }
        //     },
        //     {
        //       path: 'bmiClass',
        //       meta: { title: 'BMI分布' },
        //       component: () =>
        //         import('@/views/teachingProtection/assessment/compare/bmiClass/index.vue')
        //     },
        //     {
        //       path: 'avgClass',
        //       meta: { title: '' },
        //       component: () => import('@/views/teachingProtection/assessment/compare/avgClass/index.vue'),
        //       children: [
        //         {
        //           path: 'index',
        //           meta: { title: '综合能力排名' },
        //           component: () => import('@/views/teachingProtection/assessment/compare/avgClass/main.vue')

        //         },
        //         {
        //           path: 'detail',
        //           meta: { title: '学员详细数据' },
        //           component: () => import('@/views/teachingProtection/assessment/compare/avgClass/detail.vue')
        //         }
        //       ]
        //     },
        //     {
        //       path: 'distributionClass',
        //       meta: { title: '综合能力分布' },
        //       component: () => import('@/views/teachingProtection/assessment/compare/distributionClass/index.vue')
        //     }
        //   ]
        // },
        // {
        //   path: 'custom',
        //   meta: { title: '自定义群组', code: 264147 },
        //   component: () =>
        //     import('@/views/teachingProtection/assessment/custom/index.vue'),
        //   children: [
        //     {
        //       path: 'list',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/custom/list.vue'
        //         ),
        //       meta: { title: '列表', keepAlive: true }
        //     },
        //     {
        //       path: 'add',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/custom/add.vue'
        //         ),
        //       meta: { title: '新增', code: 474762 }
        //     },
        //     {
        //       path: 'edit',
        //       component: () =>
        //         import(
        //           '@/views/teachingProtection/assessment/custom/add.vue'
        //         ),
        //       meta: { title: '编辑', code: 474762 }
        //     }
        //   ]
        // }
      ]
    }
  ]
}
